import { useEffect } from 'react'
import { useTelegramStore } from '@/stores/telegram'

export function useTelegram() {
  const { 
    telegramUser, 
    webApp, 
    initData, 
    platform, 
    colorScheme, 
    isReady, 
    source,
    setMiniAppUser,
    clearUser
  } = useTelegramStore()

  useEffect(() => {
    if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp
      
      console.log('useTelegram: Detected Telegram Web App environment')
      
      // Initialize Telegram Web App
      tg.ready()
      tg.expand()
      
      // Set theme
      tg.setHeaderColor('#2481cc')
      
      const miniAppUser = tg.initDataUnsafe.user
      if (miniAppUser) {
        console.log('useTelegram: Mini App user detected:', miniAppUser)
        setMiniAppUser(tg, miniAppUser)
      } else {
        console.log('useTelegram: No Mini App user data available')
      }
    } else {
      console.log('useTelegram: Not in Telegram Web App environment')
    }
  }, [])

  const showMainButton = (text: string, onClick: () => void) => {
    if (webApp?.MainButton) {
      webApp.MainButton.setText(text)
      webApp.MainButton.onClick(onClick)
      webApp.MainButton.show()
    }
  }

  const hideMainButton = () => {
    if (webApp?.MainButton) {
      webApp.MainButton.hide()
    }
  }

  const showBackButton = (onClick: () => void) => {
    if (webApp?.BackButton) {
      webApp.BackButton.onClick(onClick)
      webApp.BackButton.show()
    }
  }

  const hideBackButton = () => {
    if (webApp?.BackButton) {
      webApp.BackButton.hide()
    }
  }

  const hapticFeedback = (type: 'impact' | 'notification' | 'selection', style?: string) => {
    if (webApp?.HapticFeedback) {
      switch (type) {
        case 'impact':
          webApp.HapticFeedback.impactOccurred(style as any || 'medium')
          break
        case 'notification':
          webApp.HapticFeedback.notificationOccurred(style as any || 'success')
          break
        case 'selection':
          webApp.HapticFeedback.selectionChanged()
          break
      }
    }
  }

  const showAlert = (message: string) => {
    if (webApp) {
      webApp.showAlert(message)
    }
  }

  const showConfirm = (message: string) => {
    if (webApp) {
      webApp.showConfirm(message)
    }
  }

  const close = () => {
    if (webApp) {
      webApp.close()
    }
  }

  return {
    // 統一的用戶資料（兼容舊版本的 user 屬性）
    user: telegramUser,
    telegramUser,
    
    // Web App 相關
    webApp,
    isReady,
    initData,
    initDataUnsafe: webApp?.initDataUnsafe || {},
    platform,
    colorScheme,
    themeParams: webApp?.themeParams || {},
    
    // 來源信息
    source,
    isMiniApp: source === 'miniapp',
    isWidget: source === 'widget',
    
    // Actions
    showMainButton,
    hideMainButton,
    showBackButton,
    hideBackButton,
    hapticFeedback,
    showAlert,
    showConfirm,
    close,
    clearUser,
  }
}